import styled from 'styled-components'

import { LogoRoundUnstyled } from 'Components/LogoRound/unstyled'

export const LogoRound = styled(LogoRoundUnstyled)`
  display: block;
  height: 70px;
  width: 70px;
  border-radius: 50%;
`



// WEBPACK FOOTER //
// ./src/Components/LogoRound/index.js